import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import { getUID } from '@/utils';
import Vue from 'vue';

// eslint-disable-next-line global-require, import/no-dynamic-require
const packageVersion = require('../../package.json').version;

let version;
process.argv.forEach((value) => {
  const reg = new RegExp(/^--version=/);
  if (reg.test(value)) {
    version = value.replace(reg, '');
  }
});

class Monitor {
  static dsn = 'https://544955a1365843c59270f6c4c3916974@sentry.quketang.com/11';
  static release = version || packageVersion;
  static Vue = Vue;


  constructor(options = {}) {
    this.options = options;
  }

  static getInstance(options) {
    if (!(this.instance instanceof this)) {
      this.instance = new this(options);
      this.instance.install();
      this.instance.registerError();
    }
    return this.instance;
  }

  install() {
    Sentry.init({
      dsn: Monitor.dsn,
      release: Monitor.release,
      environment: this.options.environment,
      integrations: [
        new Integrations.Vue({
          Vue: Monitor.Vue,
          attachProps: true,
        }),
      ],
      beforeSend(event) {
        // if (event.exception) {
        //   Sentry.showReportDialog({ eventId: event.event_id });
        // }
        return event;
      },
    });
    Sentry.configureScope((scope) => {
      const id = getUID();
      scope.setUser({ id });
    });
    // 绑定全局监控
    window.Sentry = Sentry;
  }

  registerError() {
    window.addEventListener('error', (e) => {
      if (e.target !== window) {
        const data = {
          target: e.target.localName,
          type: e.type,
          currentSrc: e.target.src,
        };
        this.log(data);
      }
    }, true);
  }

  log(data = null, type = 'error', errMsg = 'Resource error') {
    if (data instanceof Error) {
      Sentry.captureException(data);
      return;
    }
    Sentry.withScope((scope) => {
      scope.setLevel(type);
      const params = Object.assign(this.options, data);
      scope.setExtra('extra', JSON.stringify(params));
      Sentry.captureException(new Error(errMsg));
    });
  }
}

export default Monitor;
